import React, { VFC } from 'react';

import { ExternalLinks } from '../../../constants';

import discordLogo from './discord-logo.svg';
import telegramLogo from './telegram-logo.svg';
import twitterLogo from './twitter-logo.svg';
import mediumLogo from './medium-logo.svg';

import styles from './FooterSocials.module.scss';

const FooterSocials: VFC = () => (
  <div className={styles.list}>
    <a className={styles.item} href={ExternalLinks.discord} target="_blank" rel="noreferrer">
      <img className={styles.img} src={discordLogo} alt="Discord" />
    </a>

    <a className={styles.item} href={ExternalLinks.telegram} target="_blank" rel="noreferrer">
      <img className={styles.img} src={telegramLogo} alt="Telegram" />
    </a>

    <a className={styles.item} href={ExternalLinks.twitter} target="_blank" rel="noreferrer">
      <img className={styles.img} src={twitterLogo} alt="Twitter" />
    </a>

    <a className={styles.item} href={ExternalLinks.medium} target="_blank" rel="noreferrer">
      <img className={styles.img} src={mediumLogo} alt="Medium" />
    </a>
  </div>
);

export default FooterSocials;
